import angular from 'angular'

import envRaw from '../utils/env-raw'
import extractRawElm from '../utils/extract-raw-elm'
import viewportResize from '../utils/viewport-resize'

import { defaultTo } from '../utils/bits'
import { offClick, onClickPassive } from '../utils/on-click'

angular
  .module('ggs.side-click')
  .directive('ggsSideClick', SideClickDirective)

function SideClickDirective(ApplyAsync) {

  return {
    restrict: 'A',
    link($scope, $elm, $attr) {
      const elm = extractRawElm($elm)
      const handler = ApplyAsync($scope, $attr.ggsSideClick)
      const eventName = defaultTo($scope.$eval($attr.ggsSideClickEvent), envRaw.clickEvent)

      onClickPassive(elm, eventName, clickHandler)
      $scope.$on('$destroy', destroyHandler)

      function destroyHandler() {
        offClick(elm, eventName, clickHandler)
      }

      function clickHandler(event) {
        if (event.target === elm) {
          const viewportWidth = viewportResize.getWidth()
          const viewportHeight = viewportResize.getHeight()

          const viewportClickX = event.clientX
          const viewportClickY = event.clientY

          const local = {
            viewportWidth,
            viewportHeight,
            viewportClickX,
            viewportClickY
          }

          handler(local)
        }
      }
    }
  }
}
